/**
 * Kiosk Wishlist – custom.js
 * Fixes:
 *  1. Unified addToWishlist / addToKioskWishlist into one function
 *  2. Wishlist items now store & display product title + image
 *  3. Variant selector in product cards (see product-item.liquid)
 *  4. Improved UI rendering with real product info
 */

/* ─── Shared popup helper (needs to be global) ───────────────────── */
function showTransientPopup(text, ms) {
  ms = ms || 1800;
  var existing = document.getElementById('kiosk-popup');
  if (existing) existing.remove();
  var popup = document.createElement('div');
  popup.id = 'kiosk-popup';
  Object.assign(popup.style, {
    position:     'fixed',
    left:         '50%',
    top:          '10%',
    transform:    'translateX(-50%)',
    background:   '#111',
    color:        '#fff',
    padding:      '14px 22px',
    borderRadius: '10px',
    zIndex:       '9999',
    fontSize:     '15px',
    fontWeight:   '500',
    boxShadow:    '0 4px 20px rgba(0,0,0,0.35)',
    letterSpacing:'0.02em',
    transition:   'opacity 0.3s',
    opacity:      '0'
  });
  popup.textContent = text;
  document.body.appendChild(popup);
  requestAnimationFrame(() => { popup.style.opacity = '1'; });
  setTimeout(() => {
    popup.style.opacity = '0';
    setTimeout(() => popup.remove(), 320);
  }, ms);
}

/**
 * addToWishlist – called from product-item.liquid Merken buttons.
 * @param {number|string} variantId
 * @param {string}        title       – product title
 * @param {string}        imgUrl      – small product image URL
 * @param {number|string} [overrideVariantId] – if a <select> exists on the card, its value wins
 */
function addToWishlist(variantId, title, imgUrl, overrideVariantId, price) {
  window.kioskWishlist = window.kioskWishlist || [];

  // Prefer an overrideVariantId (from the inline <select>)
  var finalId = overrideVariantId ? Number(overrideVariantId) : Number(variantId);

  // Avoid exact duplicates (same variant)
  var exists = window.kioskWishlist.some(function(i) { return i.variant_id === finalId; });
  if (exists) {
    showTransientPopup('Bereits auf der Merkliste');
    return;
  }

  window.kioskWishlist.push({
    variant_id: finalId,
    quantity:   1,
    title:      title  || 'Produkt',
    image:      imgUrl || '',
    price:      parseFloat(price) || 0
  });

  if (window.renderKioskWishlist) window.renderKioskWishlist();
  showTransientPopup('✓ Zur Merkliste hinzugefügt');
}

/* Keep old name working too (backward compat) */
function addToKioskWishlist(variantId, title, imgUrl) {
  addToWishlist(variantId, title, imgUrl);
}

/* ─── Remove item from wishlist ──────────────────────────────────── */
function removeFromWishlist(variantId) {
  window.kioskWishlist = (window.kioskWishlist || []).filter(function(i) {
    return i.variant_id !== Number(variantId);
  });
  if (window.renderKioskWishlist) window.renderKioskWishlist();
}

/* ─── DOMContentLoaded: main wishlist logic ──────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  var API_URL     = 'https://isidro-serous-pseudoimpartially.ngrok-free.dev/create-draft-order';
  var KIOSK_TOKEN = 'YRMwPcNRVqEDj%6J$w1V2cJB';

  window.kioskWishlist = window.kioskWishlist || [];

  var btn     = document.getElementById('wishlist-save-btn');
  var itemsEl = document.getElementById('wishlist-items');

  /* ── Render wishlist panel items ──────────────────────────────── */
  function renderWishlistItems() {
    if (!itemsEl) return;

    if (!window.kioskWishlist.length) {
      itemsEl.innerHTML = '<li class="kiosk-empty">Merkliste ist leer</li>';
      return;
    }

    itemsEl.innerHTML = window.kioskWishlist.map(function(item) {
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + (item.title || '') + '" class="kiosk-wl-img">'
        : '<div class="kiosk-wl-img kiosk-wl-img--placeholder"></div>';

      return [
        '<li class="kiosk-wl-item" data-variant-id="' + item.variant_id + '">',
          imgHtml,
          '<div class="kiosk-wl-info">',
            '<span class="kiosk-wl-title">' + (item.title || 'Produkt') + '</span>',
            item.price > 0 ? '<span class="kiosk-wl-price">SFr. ' + item.price.toFixed(2) + '</span>' : '',
          '</div>',
          '<button class="kiosk-wl-remove" onclick="removeFromWishlist(' + item.variant_id + ')" aria-label="Entfernen">✕</button>',
        '</li>'
      ].join('');
    }).join('');

    // Total
    var totalEl = document.getElementById('kiosk-wl-total');
    if (!totalEl) {
      totalEl = document.createElement('div');
      totalEl.id = 'kiosk-wl-total';
      totalEl.className = 'kiosk-wl-total';
      itemsEl.parentNode.insertBefore(totalEl, itemsEl.nextSibling);
    }
    var total = window.kioskWishlist.reduce(function(s, i) { return s + (i.price || 0) * (i.quantity || 1); }, 0);
    totalEl.innerHTML = total > 0 ? '<span>Total</span><span>SFr. ' + total.toFixed(2) + '</span>' : '';
  }

  /* ── Send wishlist to backend ─────────────────────────────────── */
  async function sendWishlist() {
    if (!btn) return;
    if (!window.kioskWishlist.length) {
      showTransientPopup('Merkliste ist leer', 1400);
      return;
    }

    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = 'Sende…';

    try {
      var resp = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type':               'application/json',
          'x-kiosk-token':              KIOSK_TOKEN,
          'ngrok-skip-browser-warning': '1'
        },
        body: JSON.stringify({
          variants:   window.kioskWishlist.map(function(i) { return { variant_id: i.variant_id, quantity: i.quantity }; }),
          customerId: window.kioskCustomerId || null
        })
      });

      if (resp.status === 202) {
        showTransientPopup('✓ Deine Karten werden vorbereitet', 2200);
        window.kioskWishlist = [];
        renderWishlistItems();
        btn.textContent = 'Gesendet ✓';
        setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2000);
      } else {
        var json = await resp.json().catch(function() { return {}; });
        throw new Error(json.error || ('Server: ' + resp.status));
      }
    } catch (err) {
      console.error('Wishlist send error:', err);
      showTransientPopup('Fehler: ' + err.message, 2500);
      btn.textContent = origText;
      btn.disabled = false;
    }
  }

  if (btn) btn.addEventListener('click', sendWishlist);

  /* Expose so Merken-buttons can call renderWishlistItems after push */
  window.renderKioskWishlist = renderWishlistItems;
  renderWishlistItems();
});

/* ─── Wishlist panel open / close ────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  var openBtn  = document.getElementById('wishlist-open-btn');
  var panel    = document.getElementById('kiosk-wishlist');
  var closeBtn = document.getElementById('wishlist-close-btn');

  if (openBtn && panel) {
    openBtn.addEventListener('click', function() {
      panel.classList.remove('hidden');
    });
  }
  if (closeBtn && panel) {
    closeBtn.addEventListener('click', function() {
      panel.classList.add('hidden');
    });
  }
});

/* ─── cb-shipping-bar auf Kiosk-Seite ausblenden ────────────────── */
(function () {
  if (!document.body.classList.contains('collection-kiosk-cards')) return;
  function hideShippingBar() {
    var el = document.getElementById('cb-shipping-bar');
    if (el) el.style.setProperty('display', 'none', 'important');
  }
  hideShippingBar();
  var obs = new MutationObserver(hideShippingBar);
  obs.observe(document.body, { childList: true, subtree: true });
})();

/* ─── Chat-Badge auf Kiosk-Seite ausblenden ─────────────────────── */
(function () {
  if (!document.body.classList.contains('collection-kiosk-cards')) return;

  var SELECTORS = [
    '.chat-app',
    '.chat-toggle',
    'inbox-online-store-chat',
    '#shopify-chat',
    '[id*="chat"]',
    '[class*="chat-app"]'
  ];

  function hideChat() {
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
    });
  }

  // Run now, after DOM ready, and watch for late injection
  hideChat();
  document.addEventListener('DOMContentLoaded', hideChat);
  var obs = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.addedNodes.length) hideChat();
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
